import { userurl1 } from "./apiFunction";
import toast from "react-hot-toast";

const pushNotification = (notiData, e, tbName, token) => {
  if (e != null) {
    e.preventDefault();
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(notiData),
  };

  fetch(`${userurl1}collection/${tbName}`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      toast.success("Success");
    })
    .catch((error) => {
      console.error("Error:", error);
      toast.error("Failed to save data");
    });
};

export default pushNotification;
